import { InitializerExecutor } from '@wajeez-web/core/types';
import { NavigationActions } from '@wajeez-web/stores/common';
import { MdOutlineBusiness } from 'react-icons/md';
import BusinessGroupPage from './Pages/BusinessGroupPage';
import CreateBusinessGroup from './Pages/CreateBusinessGroupPage';
import { BusinessCrump } from './components/BusinessGroupCrumbs';
import { withTabs } from '@wajeez-web/core/utils';
export const initializeBusinessGroupRoutes: InitializerExecutor = async (
  dispatch
) => {
  dispatch(
    NavigationActions.updateRoutes([
      {
        name: 'Business Group',
        href: '/business-group',
        per: ['88.7'],
        icon: MdOutlineBusiness,
        children: [],
      },
    ])
  );
};

export const initializeBusinessGroupEndpoints: InitializerExecutor = async (
  dispatch
) => {
  dispatch(
    NavigationActions.updateEndpoints([
      {
        type: 'container',
        endpoint: 'business-group',
        per: ['88.7'],
        crump: 'business-group',
        children: [
          {
            type: 'endpoint',
            endpoint: 'create',
            crump: 'new',
            component: CreateBusinessGroup,
            per: [],
          },
          withTabs({
            type: 'container',
            endpoint: ':id',
            crump: BusinessCrump,
            per: [],
            children: [
              {
                type: 'endpoint',
                endpoint: '',
                component: CreateBusinessGroup,
                per: [],
              },
            ],
          }),
          {
            type: 'endpoint',
            endpoint: '',
            component: BusinessGroupPage,
            per: [],
          },
        ],
      },
    ])
  );
};
